import Api from "@/repository/api";
import {ResponseDataType} from "@/form/form.types";
import {ICounterpartiesTypeRepository} from "@/repository/finance/counterparties/CounterpartiesTypeRepository.types";
import {ICounterpartiesType, CounterpartiesTypeResponseType} from "@/entity/finance/counterparties/counterpartiesType.types";
import CounterpartiesType from "@/entity/finance/counterparties/counterpartiesType";
import {PaginationRequestType} from "@/entity/common/pagination.types";
import qs from "qs";

export class CounterpartiesTypeRepository implements ICounterpartiesTypeRepository {
    async fetchAll(data?: PaginationRequestType): Promise<CounterpartiesType[]> {
        const resp = await Api.get('/finance/counterparties/types/get', { params: data, paramsSerializer: function paramsSerializer(params) {
            return qs.stringify(params, {arrayFormat: 'repeat'})
            }});
        const respData = resp.data as CounterpartiesTypeResponseType[];
        return respData.map((item: CounterpartiesTypeResponseType) => new CounterpartiesType(item));
    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const resp = await Api.post('/finance/counterparties/types/delete', data);
        return resp.data;
    }
}